<template>
  <div>
    <footer>
      <div class="footer-down">
        <div class="container clearfix">
          <div class="eight columns">
             <span class="copyright">
                 {{$t('footer_1')}}
            </span>
          </div>
          <div class="eight columns">
            <img src="../../assets/images/partner-logo-network-transparant-rgb.png" style="height: 75px; float: right"/>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'FooterSection',
  data () {
    return {}
  }
}
</script>

<style scoped>
</style>
